import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import TokenService from "src/Services/API/token.service";

// Live "you have a new notification" events for the header bell
// (backend: UserNotificationGateway). The room is derived from the verified JWT
// server-side, so the client only ever receives its own events. Reference
// counted like the ticket socket so several consumers can share one connection.
let userNotificationSocket;
let refCount = 0;

const getUserNotificationSocket = () => {
  if (!userNotificationSocket) {
    userNotificationSocket = io(API_URL, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }

  return userNotificationSocket;
};

const connectUserNotificationSocket = () => {
  const socket = getUserNotificationSocket();
  socket.auth = {
    token: TokenService.getLocalAccessToken(),
  };

  if (!socket.connected) {
    socket.connect();
  }

  refCount++;
  return socket;
};

const disconnectUserNotificationSocket = () => {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && userNotificationSocket?.connected) {
    userNotificationSocket.disconnect();
  }
};

export {
  getUserNotificationSocket,
  connectUserNotificationSocket,
  disconnectUserNotificationSocket,
};
